import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { HrmFormInput, HrmFormSelect } from "../components/hrm_input";
import { useMeta } from "../../contexts/meta-context";
import { yupResolver } from "@hookform/resolvers/yup";
import { addMetaInfoValidation } from "../../validations/meta_info_validation";
import { APIS } from "../../api";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { userValidation } from "../../validations/userValidation";

const AddUserList = () => {
  const {
    handleSubmit,
    register,
    reset,
    watch,
    formState: { errors },
  } = useForm({ resolver: yupResolver(userValidation) });
  const navigate = useNavigate()
  const [pageList, setPageList] = useState([]);
  const { pages, onLoadPages, onAddMetaInfo } = useMeta();
  const [isMetaInfoEditFormVisible, setMetaInfoEditFormVisible] =
    useState(false);
  const [metaLoader, setMetaLoader] = useState(false);

  const fetchData = async () => {
    setMetaLoader(true);

    try {
      const { data, code, message } = await axios.post(APIS.PAGE_META_TAG);
      if (data.code == 1) {
        // setPages(data?.data);
        if (data?.data?.length > 0) {
          setPageList(
            data?.data?.map((item) => {
              return {
                label: item.label,
              };
            })
          );
        }
      } else {
        setPageList([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setPageList([]);
      setMetaLoader(false);
    } finally {
      setMetaLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [onLoadPages]);

  const onSubmit = async (values) => {
    try {
      setMetaLoader(true);
      let request = {
        role: "sub_admin",
        name: values?.name,
        email: values?.email,
        password: values?.password,
      };
      const { data } = await axios.post(
        APIS.ADD_USER,
        request
      );
      if (data.code == 1) {
        toast.success(data.message);
        navigate('/user_list')
        setMetaLoader(false);
      } else {
        toast.error(data.message);
      }
      setMetaLoader(false);
    } catch (error) {
      console.log('error', error);
      setMetaLoader(false);
    }
  };

  const handleReset = () => {
    reset();
  };

  return (
    <div>
      <div className="col-span-12 md:order-1 xl:col-span-8 2xl:col-span-6">
        <h5 className="mb-2">Add User</h5>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-12">
          <div className="card">
            <div className="card-body">
              <div className="col-md-6">

                <form onSubmit={handleSubmit(onSubmit)}>

                  <HrmFormInput
                    label={"Name"}
                    placeholder={"Enter name"}
                    {...register("name")}
                    error={errors?.name ? errors.name.message : ""}
                  />

                  <HrmFormInput
                    type={'email'}
                    label={"Email"}
                    placeholder={"Enter email"}
                    name={'email'}
                    {...register("email")}
                    error={errors?.email ? errors.email.message : ""}
                  />
                  <HrmFormInput
                    label={"Password"}
                    name={'password'}
                    placeholder={"Enter password"}
                    // {...register("password")}
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 8,
                        message: "Password must be at least 8 characters"
                      },
                      pattern: {
                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                        message:
                          "Password must include uppercase, lowercase, number, and special character"
                      }
                    })}
                    error={errors?.password ? errors.password.message : ""}
                  />

                  <div className="flex justify-center gap-2 mt-4">
                    <button
                      type="reset"
                      className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-700 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                    <button
                      type="submit"
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUserList;
